const parser = new DOMParser();
function stringToHTML(str) {
  const doc = parser.parseFromString(str, "text/html");
  return doc.body.firstElementChild;
}

const buttonsWithDataTarget = document.querySelectorAll("*[data-target]");

buttonsWithDataTarget.forEach(button => {
  const scrollTo = button.getAttribute("data-scroll-to");

  button.addEventListener("click", () => {
    const dialogId = button.dataset.target;
    const dialog = document.getElementById(dialogId);

    if (dialog) {
      setupModal(dialog, dialogId);
      dialog.showModal();

      if (scrollTo) {
        location.hash = scrollTo;
        location.href = scrollTo;
      }
    }
  });
});

function closeDialog(dialog) {
  dialog.setAttribute('closing', '');
  dialog.addEventListener('animationend', () => {
    dialog.removeAttribute('closing');
    dialog.close();
  }, {once: true});
}

function setupModal(dialog, dialogId) {
  if (!dialog) {
    console.error(`Dialog with ID ${dialogId} not found.`);
    return;
  }

  const closeButtons = dialog.querySelectorAll(".close");

  closeButtons.forEach(closeButton => {

    closeButton.addEventListener("click", () => {
      closeDialog(dialog);
    });
  });

  // console.log('setting up');

  dialog.addEventListener("click", (event) => {
    // console.log(event.target.nodeName);

    if(event.target.nodeName === 'DIALOG') {
      closeDialog(dialog);
    }
  });
}